import { Link } from "react-router-dom";
import Header from "@/components/Header";
import HeroSection from "@/components/HeroSection";
import StatsSection from "@/components/StatsSection";
import ExpertiseSection from "@/components/ExpertiseSection";
import CoverageSection from "@/components/CoverageSection";

import PartnersSection from "@/components/PartnersSection";
import CTASection from "@/components/CTASection";
import Footer from "@/components/Footer";
import KeyboardShortcuts from "@/components/KeyboardShortcuts";
import SEOHead from "@/components/SEOHead";
import { isJobVisible, jobs } from "@/data/jobs";
import { isJobExpired } from "@/utils/jobUtils";
import { generateWebsiteSearchSchema } from "@/utils/structuredData";

const activeJobCount = jobs.filter(isJobVisible).filter(job => !isJobExpired(job.closingDate)).length;

const Index = () => {
  return (
    <div className="min-h-screen">
      <SEOHead
        title="FM & Public Sector Staffing Agency | PAMP Recruitment | Nationwide"
        description="PAMP Recruitment is a UK-wide facilities management and public sector staffing agency. We supply DBS-cleared, PAYE workers to government, justice, education and housing clients across London, West Midlands, South West, Wales, Kent and the Isle of Man."
        keywords="FM staffing agency UK, facilities management recruitment, public sector staffing, DBS cleared workers, PAYE staffing agency, government cleaning contracts, MOJ staffing, probation service cleaning, school cleaning staff, housing support workers, West Midlands recruitment, nationwide FM agency, MSP supplier UK, PSL recruitment agency"
        structuredData={generateWebsiteSearchSchema()}
      />
      <Header />
      <main id="main-content">
        <HeroSection />
        <StatsSection />
        <div className="border-b border-border bg-card/40 py-4">
          <p className="container mx-auto px-6 text-center text-sm text-muted-foreground">
            <span className="font-medium text-foreground">DBS-cleared</span> · <span className="font-medium text-foreground">PAYE-compliant</span> · <span className="font-medium text-foreground">Equality Act 2010</span> ·{" "}
            <Link to="/equality-diversity-inclusion" className="font-medium text-primary underline-offset-4 hover:underline">
              Equality, Diversity & Inclusion
            </Link>
          </p>
        </div>
        <ExpertiseSection />
        <CoverageSection />
        
        <PartnersSection />
        <CTASection />
      </main>
      <Footer />
      <KeyboardShortcuts />
    </div>
  );
};

export default Index;
